module.exports = __webpack_public_path__ + "img/4.968b7f1b.jpg";